import type { DateTime } from 'luxon';
import { type FC, useContext } from 'react';

import { SlabContext } from '@core/context/SlabContext';
import { reminderTriggerHint } from '@core/utils/reminders';

import { InfoBanner } from '../Banner/InfoBanner';
import { WarningBanner } from '../Banner/WarningBanner';

export const ReminderTriggerHintBanner: FC<{ triggerDate: DateTime }> = ({ triggerDate }) => {
  const { timezone } = useContext(SlabContext).userInfo.tenant;
  const { isPast, message } = reminderTriggerHint(triggerDate, timezone);

  return isPast ? <WarningBanner>{message}</WarningBanner> : <InfoBanner>{message}</InfoBanner>;
};
